<div class="app-container">
  <!-- Header Navigation  -->
  <header class="main-header">
    <div class="brand-header">
      <div class="brand-icon-header">D</div>
    </div>

    <!-- Breadcrumb Navigation -->
    <div class="breadcrumb-nav">
      <button class="breadcrumb-link" (click)="navigateToSequencing()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="10" y1="6" x2="21" y2="6"></line>
          <line x1="10" y1="12" x2="21" y2="12"></line>
          <line x1="10" y1="18" x2="21" y2="18"></line>
          <path d="M4 6h1v4"></path>
          <path d="M4 10h2"></path>
          <path d="M6 18H4c0-1 2-2 2-3s-1-1.5-2-1"></path>
        </svg>
        Sequencing
      </button>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="breadcrumb-separator">
        <polyline points="9 18 15 12 9 6"></polyline>
      </svg>
      <span class="breadcrumb-current">Document Manager</span>
    </div>
    
    <!-- Eval Tabs (only show when Eval tab is active) -->
    <div class="eval-tabs" *ngIf="activeTab === 'eval'">
      <button 
        class="eval-tab" 
        [class.active]="evalTab === 'extraction'" 
        (click)="setEvalTab('extraction')">
        Extraction Eval
      </button>
      <button 
        class="eval-tab" 
        [class.active]="evalTab === 'versioning'" 
        (click)="setEvalTab('versioning')">
        Versioning Eval
      </button>
    </div>

    <!-- Navigation Buttons in Header -->
    <div class="header-nav-buttons">
      <button class="header-nav-btn" [class.active]="activeTab === 'sequencing'" (click)="navigateToSequencing()" title="Sequencing">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="nav-icon">
          <line x1="10" y1="6" x2="21" y2="6"></line>
          <line x1="10" y1="12" x2="21" y2="12"></line>
          <line x1="10" y1="18" x2="21" y2="18"></line>
          <path d="M4 6h1v4"></path>
          <path d="M4 10h2"></path>
          <path d="M6 18H4c0-1 2-2 2-3s-1-1.5-2-1"></path>
        </svg>
      </button>
      <button class="header-nav-btn" [class.active]="activeTab === 'dataextraction'" (click)="navigateToDataExtraction()" title="Data Extraction">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="nav-icon">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
          <polyline points="14 2 14 8 20 8"></polyline>
          <line x1="16" y1="13" x2="8" y2="13"></line>
          <line x1="16" y1="17" x2="8" y2="17"></line>
          <polyline points="10 9 9 9 8 9"></polyline>
        </svg>
      </button>
      <button class="header-nav-btn" [class.active]="activeTab === 'versioning'" (click)="navigateToVersioning()" title="Versioning">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="nav-icon">
          <line x1="6" y1="3" x2="6" y2="15"></line>
          <circle cx="18" cy="6" r="3"></circle>
          <circle cx="6" cy="18" r="3"></circle>
          <path d="M18 9a9 9 0 0 1-9 9"></path>
        </svg>
      </button>
      <button class="header-nav-btn" [class.active]="activeTab === 'externalmapping'" (click)="navigateToExternalMapping()" title="External Mapping">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="nav-icon">
          <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
          <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
          <line x1="12" y1="22.08" x2="12" y2="12"></line>
        </svg>
      </button>

    </div>
  </header>

  <!-- Main Content - Three Column Layout -->
  <main class="content-grid" *ngIf="activeTab === 'sequencing'">
    
    <!-- Column 1: Document Upload -->
    <section class="column upload-column">
      <div class="card">
        <div class="title-with-button">
          <h2 class="card-title">Document Type</h2>
          <button class="btn-add-document" (click)="showAddDocumentModal()" title="Add New Document">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
            Add Document
          </button>
        </div>

        <!-- Display hierarchical document structure -->
        <div class="document-tree" *ngIf="documents.length > 0">
          <div *ngFor="let doc of documents" class="tree-item document-item">
            <div class="tree-row" (click)="toggleDocument(doc)">
              <svg class="tree-icon" [class.expanded]="doc.expanded" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
              <svg class="file-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
              </svg>
              <span class="tree-label">{{ doc.name }}</span>
            </div>
            
            <div *ngIf="doc.expanded" class="tree-children">
              <div *ngFor="let docType of doc.documentTypes" class="tree-item doctype-item">
                <div class="tree-row" (click)="toggleDocumentType(docType)">
                  <svg class="tree-icon" [class.expanded]="docType.expanded" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                  <svg class="file-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z"></path>
                    <polyline points="13 2 13 9 20 9"></polyline>
                  </svg>
                  <span class="tree-label">{{ docType.name }} ({{ docType.key }})</span>
                </div>
                
                <div *ngIf="docType.expanded" class="tree-children">
                  <div *ngFor="let pdf of docType.pdfs" class="tree-item pdf-item" [class.selected]="selectedPdf?.id === pdf.id" (click)="selectPdf(doc, docType, pdf)">
                    <div class="tree-row">
                      <svg class="file-icon pdf-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                        <polyline points="14 2 14 8 20 8"></polyline>
                      </svg>
                      <span class="tree-label">{{ pdf.name }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="empty-state-small" *ngIf="documents.length === 0">
          <p>No documents uploaded</p>
          <p class="empty-subtitle">Click "Add Document" to get started</p>
        </div>
      </div>
    </section>

    <!-- Column 2: PDF Viewer -->
    <section class="column viewer-column">
      <div class="card viewer-card">
        <div class="viewer-header-inline">
          <h2 class="card-title">Document Preview</h2>
          <div class="viewer-controls-inline">
            <div class="page-controls">
              <button class="control-btn" (click)="previousPage()" [disabled]="!pdfSrc || currentPage === 1" title="Previous Page">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
              </button>
              <span class="page-counter">{{ pdfSrc ? currentPage + '/' + totalPages : '0/0' }}</span>
              <button class="control-btn" (click)="nextPage()" [disabled]="!pdfSrc || currentPage === totalPages" title="Next Page">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              </button>
            </div>
            <div class="zoom-controls">
              <button class="control-btn" (click)="zoomOut()" [disabled]="!pdfSrc || zoom <= 0.5" title="Zoom Out">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="8" y1="11" x2="14" y2="11"></line>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
              </button>
              <span class="zoom-level">{{ (zoom * 100) | number:'1.0-0' }}%</span>
              <button class="control-btn" (click)="zoomIn()" [disabled]="!pdfSrc || zoom >= 3.0" title="Zoom In">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="11" y1="8" x2="11" y2="14"></line>
                  <line x1="8" y1="11" x2="14" y2="11"></line>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div class="pdf-container">
          <div *ngIf="!pdfSrc" class="empty-state">
            <svg class="empty-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
              <polyline points="14 2 14 8 20 8"></polyline>
            </svg>
            <p>No document loaded</p>
            <p class="empty-subtitle">Upload a PDF to preview</p>
          </div>

          <div *ngIf="pdfSrc" style="height: 100%; overflow: auto;">
            <pdf-viewer 
              [src]="pdfSrc" 
              [render-text]="true"
              [original-size]="false"
              [show-all]="false"
              [page]="currentPage"
              [zoom]="zoom"
              (after-load-complete)="onPdfLoadComplete($event)"
              style="width: 100%; height: 100%;"
            ></pdf-viewer>
          </div>
        </div>
      </div>
    </section>

    <!-- Column 3: Page Annotations -->
    <section class="column annotation-column">
      <div class="card">
        <h2 class="card-title-no-border">Page Info</h2>

        <div class="form-group">
          <label for="annotationDocType">Document Type</label>
          <select 
            id="annotationDocType"
            class="form-select"
            [(ngModel)]="annotation.documentType"
          >
            <option value="">Select document type</option>
            <option *ngFor="let type of documentTypes" [value]="type">{{ type }}</option>
          </select>
        </div>

        <div class="form-group">
          <label for="keySelect">Select Key for Page</label>
          <select 
            id="keySelect"
            class="form-select"
            [(ngModel)]="annotation.key"
          >
            <option value="">Select key</option>
            <option *ngFor="let key of keyOptions" [value]="key">{{ key }}</option>
          </select>
        </div>

        <div class="form-group">
          <label for="templateName">Template Name</label>
          <input 
            type="text" 
            id="templateName"
            class="form-input"
            [(ngModel)]="annotation.templateName"
            placeholder="Enter template name"
            list="templateNameList"
          />
          <datalist id="templateNameList">
            <option *ngFor="let name of templateNames" [value]="name">{{ name }}</option>
          </datalist>
        </div>

        <div class="checkbox-group">
          <label class="checkbox-label">
            <input 
              type="checkbox" 
              class="checkbox-input"
              [(ngModel)]="annotation.firstPage"
            />
            <span class="checkbox-text">First Page</span>
          </label>

          <label class="checkbox-label">
            <input 
              type="checkbox" 
              class="checkbox-input"
              [(ngModel)]="annotation.lastPage"
            />
            <span class="checkbox-text">Last Page</span>
          </label>
        </div>

        <button 
          class="btn btn-primary"
          (click)="saveAnnotation()"
        >
          Save Annotations
        </button>
      </div>
    </section>

  </main>

  <!-- Eval Page -->
  <main class="eval-page" *ngIf="activeTab === 'eval'">
    <!-- Extraction Eval Tab Content - Show Accuracy Page (Loan Validation) -->
    <div class="eval-content" *ngIf="evalTab === 'extraction'">
      <app-loan-validation></app-loan-validation>
    </div>

    <!-- Versioning Eval Tab Content - Placeholder for now -->
    <div class="eval-content versioning-placeholder" *ngIf="evalTab === 'versioning'">
      <div class="placeholder-content">
        <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" class="placeholder-icon">
          <line x1="6" y1="3" x2="6" y2="15"></line>
          <circle cx="18" cy="6" r="3"></circle>
          <circle cx="6" cy="18" r="3"></circle>
          <path d="M18 9a9 9 0 0 1-9 9"></path>
        </svg>
        <h2 class="placeholder-title">Versioning Eval</h2>
        <p class="placeholder-description">This section is under development</p>
      </div>
    </div>
  </main>

  <!-- Blank Pages for Data Extraction, Versioning, External Mapping -->
  <main class="blank-page" *ngIf="activeTab === 'dataextraction' || activeTab === 'versioning' || activeTab === 'externalmapping'">
    <!-- Empty content - only header shows -->
  </main>

  <!-- Add Document Modal -->
  <div class="modal-overlay" *ngIf="showModal" (click)="closeModal()">
    <div class="modal-dialog" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3 class="modal-title">Add New Document</h3>
        <button class="modal-close" (click)="closeModal()" title="Close">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      
      <div class="modal-body">
        <div class="form-group">
          <label for="modalDocName">Document Name</label>
          <input 
            type="text" 
            id="modalDocName"
            class="form-input"
            [(ngModel)]="newDocument.documentName"
            placeholder="Enter document name"
          />
        </div>

        <div class="form-group">
          <label for="modalDocType">Document Type</label>
          <input 
            type="text" 
            id="modalDocType"
            class="form-input"
            [(ngModel)]="newDocument.documentType"
            placeholder="Enter document type"
          />
        </div>

        <div class="form-group">
          <label for="modalDocKey">Document Key</label>
          <input 
            type="text" 
            id="modalDocKey"
            class="form-input"
            [(ngModel)]="newDocument.key"
            placeholder="Enter document key"
          />
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="closeModal()">Cancel</button>
        <button class="btn btn-primary" (click)="saveAndUpload()" [disabled]="!newDocument.documentName || !newDocument.documentType || !newDocument.key">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-right: 0.5rem;">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
            <polyline points="17 8 12 3 7 8"></polyline>
            <line x1="12" y1="3" x2="12" y2="15"></line>
          </svg>
          Save & Upload
        </button>
      </div>
      
      <input 
        #modalFileInput
        type="file" 
        accept="application/pdf"
        (change)="onModalFileSelected($event)"
        class="file-input"
        style="display: none;"
      />
    </div>
  </div>
</div>

